import { NgModule } from "@angular/core";
import { SwiperBannerComponent } from "./components/swiperBanner.component";
import { SwiperBannerContainerComponent } from "./swiperBanner-container.component";
import { SwiperModule } from 'swiper/angular';
import { SharedModule } from "../shared/shared.module";

@NgModule({
    declarations: [
        SwiperBannerContainerComponent,
        SwiperBannerComponent
    ],
    imports: [
      SharedModule,
    ],
    providers: [
      {
        provide: 'components',
        useValue: [SwiperBannerContainerComponent, SwiperBannerComponent],
        multi: true
      }
    ],
    entryComponents: [
      SwiperBannerContainerComponent
    ],
  })
  export class SwiperBannerModule { }